import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { BMApiService } from '../../../services/bm.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../services/user.service';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  GridStateChange
} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UtilityService } from '../../../services/utility.service';
import { AdminApiService } from '../../../services/admin.service';
import { tranbenchmarkkpi, tranbenchmarkkpihistory, benchmarkkpirelease, benchmarkkpientry, bmKPIPerformanceTrend, kpiDynamic } from '../../../models/slakpi';
import { division } from '../../../models/admin';
import { ToasterService } from '../../../toaster.service';
import { FormControl, FormGroup } from '@angular/forms';
import { RSAHelper } from '../../../models/RSAHelper';
declare var google: any;
@Component({
  selector: 'app-bench-mark-kpi-view',
  templateUrl: './bench-mark-kpi-view.component.html',
  styleUrls: ['./bench-mark-kpi-view.component.css']
})
export class BenchMarkKPIViewComponent implements OnInit {
  chartOption: any = {};
  public benchMarkYear_data: any;
  public currentHalf_data: any;
  public division_data: any;
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  buttonType: any;
  public kpiCommentForm: FormGroup;
  public kpiApproveRejectForm: FormGroup;
  @ViewChild('viewtemplate', { static: false }) viewtemplate: TemplateRef<any>;
  @ViewChild('CommentDialog', { static: false }) CommentDialog: TemplateRef<any>;
  @ViewChild('ApproveRejectDialog', { static: false }) ApproveRejectDialog: TemplateRef<any>;
  
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  yearfilter: any;
  divisionUnofilter: any;
  halffilter: any;
  angularGrid: AngularGridInstance;
  public BenchmarkKPIRelease_data: any;
  public loading: boolean = true;
  public pageAction: string = 'add';
  tranBenchMarkKPIHistory_data: any;
  isStart:boolean=true;
  selectedRows: any = [];
  public uploadedFiles: Array<File> = [];
  BMKPIPerformanceTrend_data: any = [];
  public dynamicAttachments: any = [];
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean;
  statusUno: number = 1;
  kpiBenchMarkTrnUno: any;
  kpiCodeDetail: any;
  isChartVisible: boolean = false;
  multipleBemchMarkEntry = [];
  objTranBenchmarkKPI: tranbenchmarkkpi;
  comments: string='';
  txtTranActualValue: string='';
  public currentLevelUser: string = '';
  public currentLevel: number;
  public isCurrentLevelUser: boolean = false;

  noDataImg: any;
  tenantUno: any;
  constructor(public restApi: BMApiService, private _activatedRoute: ActivatedRoute, public restAdminApi: AdminApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService,public RASHelper: RSAHelper) {

    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
  }

  kpipertrend = (option_data: any) => {
    
    let tempArray_XAxis = [];
    let tempArray_Target = [];
    let tempArray_Actual = [];

    //let tempArray = [['Year', 'Actual', 'Target']];
    //for (var i = 0; i < option_data.length; i++) {
    //  tempArray.push([option_data[i].benchmarkYear, parseInt(option_data[i].actualValue), parseInt(option_data[i].targetValue)]);
    //}

    for (var i = 0; i < option_data.length; i++) {
      let kpiYearName = option_data[i].benchmarkYear;
      let actualTargetValue = (option_data[i].actualValue != null && option_data[i].actualValue > 0) ? option_data[i].actualValue : 0;
      let targetValue = (option_data[i].targetValue != null && option_data[i].targetValue > 0) ? option_data[i].targetValue : 0;
      
      tempArray_XAxis.push(kpiYearName);
      tempArray_Actual.push(actualTargetValue);
      tempArray_Target.push(targetValue);
    }
    

    this.chartOption = {
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['Actual', 'Target'],
        bottom: '0',
        left: 'center',
        //padding: [
        //  20,  // up
        //  0, // right
        //  0,  // down
        //  0, // left
        //],
      },
      color: ['#68b097', '#9e9e9e'],
      toolbox: {
        show: true,
        feature: {
          //dataView: { show: true, readOnly: false },
          //magicType: { show: true, type: ['line', 'bar'] },
          //restore: { show: true },
          //saveAsImage: { show: true }
        }
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          data: tempArray_XAxis
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      grid: {
        left: '0',
        top: '10%',
        right: '0',
        bottom: '10%',
        containLabel: true
      },
      //dataZoom: [
      //  {
      //    show: true,
      //    start: 1,
      //    end: 100,
      //    right: '2%',
      //    left: '5%',
      //    top: '85%',
      //  },


      //],
      series: [

        {
          name: 'Actual',
          type: 'bar',
          data: tempArray_Actual,
          barWidth: "10%",

        },
        {
          name: 'Target',
          type: 'bar',
          data: tempArray_Target,
          barWidth: "10%",

        }
      ]
    };
  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.isAdmin = (this.user.role == 'Administrator') ? true : false;
    this.isChartVisible = false;

    this.uploadedFiles = [];
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,
      enableCheckboxSelector: true,
      checkboxSelector: {
        // optionally change the column index position of the icon (defaults to 0)
        // columnIndexPosition: 1,

        // remove the unnecessary "Select All" checkbox in header when in single selection mode
        hideSelectAllCheckbox: false,

        // you can override the logic for showing (or not) the expand icon
        // for example, display the expand icon only on every 2nd row
        // selectableOverride: (row: number, dataContext: any, grid: any) => (dataContext.id % 2 === 1)
      },
      multiSelect: false,
      rowSelectionOptions: {
        // True (Single Selection), False (Multiple Selections)
        selectActiveRow: true,
      },



    };
    this._activatedRoute.params.subscribe((params: Params) => {

      if (params['id'] != null) {
        let kpiTrnUnoTemp = params['id'];
        this.kpiBenchMarkTrnUno = kpiTrnUnoTemp;
        this.loadKPICodeDetails(this.kpiBenchMarkTrnUno);
        this.getBenchmarkTranKPIEntry(this.kpiBenchMarkTrnUno);
        this.getBenchMarkHistory(this.kpiBenchMarkTrnUno);
        this.getBenchmarkKPIAttachments(this.kpiBenchMarkTrnUno);
      }
    });
    //this.LoadBenchmarkKPIRelease();
    //google.charts.load('current', { 'packages': ['bar'] });
    //google.charts.setOnLoadCallback(this.kpipertrend);

    this.kpiCommentForm = new FormGroup({
      comment: new FormControl()
    });

    this.kpiApproveRejectForm = new FormGroup({
      comment: new FormControl()
    });
    
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }
 


  

  //Get KPI Code Details
  loadKPICodeDetails(kpiTrnUno: number) {
    
    this.spinner.show();
    let inpValue = new tranbenchmarkkpi();
    inpValue.trnBenchmarkUno = kpiTrnUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 2;
    inpValue.userUno = this.login_UserID;

    this.restApi.getBenchmarkKpiCodeDetails(inpValue)
      .subscribe(data => {
        
        //this.data = data;
        if (data != null && data != undefined) {
          //this.kpiCodeDetail = new kpiInbox();
          this.kpiCodeDetail = data[0];
          this.checkCurrentUserAndLevel(data);
          this.loadKPIPerformanceTrend(this.kpiCodeDetail.kpiUno);
          if (this.kpiCodeDetail != null && this.kpiCodeDetail.dataOwnerActionBy == '') {
            
            this.comments = this.kpiCodeDetail.dataOwnerComments;
          }

          this.txtTranActualValue = this.kpiCodeDetail.actualValue;
          

          

        }
        this.spinner.hide();
        this.isChartVisible = true;
        this.loading = false;
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  loadKPIPerformanceTrend(kpiUno: number) {
    
    this.spinner.show();
    let inpValue = new bmKPIPerformanceTrend();
    inpValue.kpiUno = kpiUno;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getBMKPIPerformanceTrend(inpValue)
      .subscribe(data => {
        
        //this.data = data;
        if (data != null && data != undefined) {
          
         this.BMKPIPerformanceTrend_data = data;

          setTimeout(() => {
            //google.charts.load('current', { 'packages': ['bar'] });
            //google.charts.setOnLoadCallback(this.kpipertrend(this.BMKPIPerformanceTrend_data));
            this.kpipertrend(this.BMKPIPerformanceTrend_data);
          }, 700);


        }
        this.spinner.hide();
        this.isChartVisible = true;
        this.loading = false;
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      {
        id: 'kpiCode', name: 'KPI Code', field: 'kpiCode', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiCode', 'kpiCode'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiNameEn', name: 'KPI', field: 'kpiNameEn', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiNameEn', 'kpiNameEn'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'dataOwnerName', name: 'Owner', field: 'dataOwnerName', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'dataOwnerName', 'dataOwnerName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'targetValue', name: 'Target', field: 'targetValue', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'targetValue', 'targetValue'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'kpiRule', name: 'KPI Rule', field: 'kpiRule', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'kpiRule', 'kpiRule'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'rowType', name: 'Row Type', field: 'rowType', sortable: true,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'rowType', 'rowType'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue', width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            //{
            //  command: 'delete-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'View History',
            //  iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
            //  action: (e, args) => {
            //    this.pageAction = 'view';
            //    let rdata: any = args.dataContext;
            //    this.getViewHistory(rdata.id);

            //    this.modalRef = this.modalService.show(
            //      this.viewtemplate,
            //      Object.assign({}, { class: 'gray modal-lg' })
            //    );
                
            //  },
            //  // only show command to 'Delete Row' when the task is not completed

            //},
            //{ divider: true, command: '', positionOrder: 63 },
            {
              command: 'release-row', titleKey: 'Release_ROW', positionOrder: 66, title: 'KPI Release',
              iconCssClass: 'fa fa-send', cssClass: 'green', textCssClass: 'bold',
              action: (e, args) => {
                this.selectedRows = [];
                let data = args.dataContext;

                let mockDataset = [];
               mockDataset.push({
                 id: data.id,
                 kpiCode: data.kpiCode,
                 kpiNameEn: data.kpiNameEn,
                 dataOwnerName: data.dataOwnerName,
                 dataOwnerUno: data.dataOwnerUno,
                 level1ApproverUno: data.level1ApproverUno,
                 level2ApproverUno: data.level2ApproverUno,
                 level3ApproverUno: data.level3ApproverUno,
                 targetValue: data.targetValue,
                 kpiRule: data.kpiRule,
                  rowType: data.rowType
                });

                this.selectedRows = mockDataset;
                
              },
              // only show command to 'Delete Row' when the task is not completed

            },


          ],
        }
      }




    ]


  }


  getBenchMarkHistory(id: number) {
    

      let inpValue = new tranbenchmarkkpihistory();

    inpValue.itemUno = id;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
      this.restApi.getTranBenchMarkKPIHistory(inpValue)
        .subscribe(data => {
          
          this.tranBenchMarkKPIHistory_data = data;
        },
          (error) => {
            //Called when error
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
        });
    
  }

  getBenchmarkTranKPIEntry(itemUno: any) {
    
    let inpValue = new tranbenchmarkkpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = itemUno;
    inpValue.condition = 1;
    inpValue.userUno = this.login_UserID;
    this.multipleBemchMarkEntry = [];
    this.restApi.getBenchMarkKPIEntry(inpValue)
      .subscribe((data: any) => {
        
        let rtn_data = data;
        if (rtn_data != null && rtn_data.length > 0) {
          let entryList = [];
          for (var i = 0; i < rtn_data.length; i++) {
           // $('#txtActualValue_' + i).val(rtn_data[i].actualValue);

           

            let objBenchmarkEntry = {


              kpiUno: rtn_data[i].kpiUno,
              benchmarkYear: rtn_data[i].benchmarkYear,
              benchmarks: rtn_data[i].benchmarks,
              sourceUno: rtn_data[i].sourceUno,
              peerUno: rtn_data[i].peerUno,
              considerationUno: rtn_data[i].considerationUno,
              filter: rtn_data[i].filter,
              targetValue: rtn_data[i].targetValue,
              actualValue: (rtn_data[i].actualValue == 0) ? '' : rtn_data[i].actualValue,
              sourceName: rtn_data[i].sourceName,
              peerName: rtn_data[i].peerName,
              considerationName: rtn_data[i].considerationName

            }
            entryList.push(objBenchmarkEntry);
          }

          this.multipleBemchMarkEntry = entryList;
          
        }
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }
  
  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val;
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }

  checkCurrentUserAndLevel(data: any) {
    
    this.currentLevelUser = '';
    this.currentLevel = 1;
    //checking Current level

    //currentLevel 1 - Data Entry
    //currentLevel 2 - Level 1 
    //currentLevel 3 - Level 2 
    //currentLevel 4 - Level 3
    let dataEntry = data[0].dataOwnerActionBy;
    let level1Approved = data[0].level1Approved;
    let level2Approved = data[0].level2Approved;
    let level3Approved = data[0].level3Approved;

    if (dataEntry == "" && level1Approved == 0 && level2Approved == 0 && level3Approved == 0) {
      this.currentLevel = 1;
      this.currentLevelUser = data[0].dataOwnerUno;
    }
    else if (dataEntry != "" && level1Approved == 0 && level2Approved == 0 && level3Approved == 0) {
      this.currentLevel = 2;
      this.currentLevelUser = data[0].level1ApproverUno;
    }
    else if (dataEntry != "" && level1Approved == 1 && level2Approved == 0 && level3Approved == 0) {
      this.currentLevel = 3;
      this.currentLevelUser = data[0].level2ApproverUno;
    }
    else if (dataEntry != "" && level1Approved == 1 && level2Approved == 1 && level3Approved == 0) {
      this.currentLevel = 4;
      this.currentLevelUser = data[0].level3ApproverUno;
    }

    if (level1Approved == 1 && level2Approved == 1 && level3Approved == 1) {
      this.currentLevel = 5;
    }

    // second approver, third approver are non mandatory
    if (level1Approved == 1 && level2Approved == 0 && level3Approved == 0) {
      this.kpiCodeDetail.level2ApprovedBy = '';
      this.kpiCodeDetail.level3ApprovedBy = '';
      this.kpiCodeDetail.statusUno = 5;
      this.currentLevel = 5;
    }

    //Checking whether loggged user and current level user same or not
    //this.kpiCodeDetail.currentLevel = currentLevel;

    //currentLevelUser = "2,3";
    let login_UserID = this.RASHelper.decryptWithPrivateKey(this.login_UserID.toString());
    if (this.currentLevelUser.toString().indexOf(',') > -1) {
      
      let userArr = this.currentLevelUser.toString().split(',');
      for (let num of userArr) {
        
        if (login_UserID.toString() == num) {
          this.isCurrentLevelUser = true;
        }
      }
    }
    else {
      if (login_UserID.toString() == this.currentLevelUser.toString()) {
        this.isCurrentLevelUser = true;
      }
    }

    if (this.isAdmin) { this.isCurrentLevelUser = true; }
  }


  onApproveBenchMarkEntry(type) {
    
    if (this.uploadedFiles && this.uploadedFiles.length > 0) {
      //Check file count 
      if (this.uploadedFiles.length > 5) {
        this.toaster.show('error', 'Error', 'Maximum 5 Files to be upload.');
        return;
      }

      for (var i = 0; i < this.uploadedFiles.length; i++) {
        let fileName = this.uploadedFiles[i].name.toLowerCase();
        let fileSize = this.uploadedFiles[i].size;
        //Check file size
        if (!this.userService.checkFileSize(fileSize)) {
          this.toaster.show('error', 'Error', 'A file size should not above 30MB.');
          return;
        }

        //To check file exe
        if (!this.userService.checkFileValuranabity(fileName, fileSize)) {
          this.toaster.show('error', 'Error', 'Please select the correct formate file.');
          return;
        }
      }
    }

    if (type == 'send' || type == 'save') {
    //  let isEmpty = false;
    //  let rtn_data = this.multipleBemchMarkEntry;
      //let multipleTrnBemchMarkEntry = [];


      //for (var i = 0; i < rtn_data.length; i++) {
      //  let actualValue = $('#txtActualValue_' + i).val();
      //  if (actualValue == '' ) {
      //    isEmpty = true;
      //  }
      //  let objBenchmarkEntry = {

      //    kpiUno: rtn_data[i].kpiUno,
      //    benchmarkYear: rtn_data[i].benchmarkYear,
      //    benchmarks: rtn_data[i].benchmarks,
      //    sourceUno: rtn_data[i].sourceUno,
      //    peerUno: rtn_data[i].peerUno,
      //    considerationUno: rtn_data[i].considerationUno,
      //    filter: rtn_data[i].filter,
      //    targetValue: rtn_data[i].targetValue,
      //    actualValue: actualValue,
      //    sourceName: rtn_data[i].sourceName,
      //    peerName: rtn_data[i].peerName,
      //    considerationName: rtn_data[i].considerationName
      //  }

      //  

      //  multipleTrnBemchMarkEntry.push(objBenchmarkEntry);
      //}
      
      
      if (this.txtTranActualValue == null && type == 'send') {
        this.toaster.show('warning', 'Warning', 'Please enter the actual value.');
        return false;
      }
      
      this.txtTranActualValue = this.txtTranActualValue.toString();
     

    if (this.txtTranActualValue== "" && type == 'send') {
      this.toaster.show('warning', 'Warning', 'Please enter the actual value.');
      return false;
    }

      //if (type == 'send' && isEmpty == true) {
      // // Swal.fire('Error', 'Please enter the actual value.', 'error');
      //  this.toaster.show('warning', 'Warning', 'Please enter the actual value.');
      //  return false;
      //}
      //XML Value For KPIBenchMark Entry

      //let entryItems = multipleTrnBemchMarkEntry;
      //let strXmlValue = '<roots></roots>';
      //if (entryItems.length > 0) {


      //  for (var i = 0; i < entryItems.length; i++) {

      //    strXmlValue += "<root>";
      //    strXmlValue += "<BenchMarkKPIUno>" + entryItems[i].kpiUno + "</BenchMarkKPIUno>";
      //    strXmlValue += "<BenchMarkYear>" + entryItems[i].benchmarkYear + "</BenchMarkYear>";
      //    strXmlValue += "<SourceUno>" + entryItems[i].sourceUno + "</SourceUno>";
      //    strXmlValue += "<PeerUno>" + entryItems[i].peerUno + "</PeerUno>";
      //    strXmlValue += "<ConsiderationUno>" + entryItems[i].considerationUno + "</ConsiderationUno>";
      //    strXmlValue += "<Filter>" + entryItems[i].filter + "</Filter>";
      //    strXmlValue += "<BenchMark>" + entryItems[i].benchmarks + "</BenchMark>";
      //    strXmlValue += "<TargetValue>" + entryItems[i].targetValue + "</TargetValue>";
      //    strXmlValue += "<ActualValue>" + entryItems[i].actualValue + "</ActualValue>";
      //    strXmlValue += "</root>";
      //  }
      //  strXmlValue += '</roots>';

      //}
      
     this.ApproveProcessBenchMarkEntry('', type);
    }
    else {
      if (type == 'reject') {
        if (this.comments == '') {
          //Swal.fire('Error', 'Please enter the comments', 'error');
          this.toaster.show('warning', 'Warning', 'Please enter the comments.');
          return false;
        }
      }
      this.ApproveProcessBenchMarkEntry('', type);
    }

   

    
    return false;
  }
  ApproveProcessBenchMarkEntry(strXmlValue:string, type: any) {
    debugger;

    let objTranBenchmarkKPI = new tranbenchmarkkpi;

    objTranBenchmarkKPI.userUno = this.login_UserID;
    objTranBenchmarkKPI.trnBenchmarkUno = this.kpiBenchMarkTrnUno;
    objTranBenchmarkKPI.statusUno = this.kpiCodeDetail.statusUno;
    objTranBenchmarkKPI.comments = this.comments;//
    objTranBenchmarkKPI.xmlData = strXmlValue;
    objTranBenchmarkKPI.tenantUno = this.tenantUno;
    let message = ''
    objTranBenchmarkKPI.condition = 0;
    if (type == 'save') {
      objTranBenchmarkKPI.condition = 0;
      message = 'Data Entry saved.';
    }
    else if (type == 'send') {
      objTranBenchmarkKPI.condition = 1;

      message = 'Sent for approval.';
    }
    else if (type == 'approve') {
      objTranBenchmarkKPI.condition = this.currentLevel;
      message = 'Approved Successfully.';
    }
    else if (type == 'reject') {
      objTranBenchmarkKPI.condition = this.currentLevel + 3;
      message = 'Rejected Successfully.';
    }

    if (type == 'Comment' && this.currentLevel == 1) {  //Data Entry Level Comment
      objTranBenchmarkKPI.condition = 8;
      message = 'Comment Saved Successfully.';
    }
    if (type == 'Comment' && this.currentLevel == 2) { //Level1 Comment
      objTranBenchmarkKPI.condition = 9;
      message = 'Comment Saved Successfully.';
    }
    if (type == 'Comment' && this.currentLevel == 3) {//Level2 Comment
      objTranBenchmarkKPI.condition = 10;
      message = 'Comment Saved Successfully.';
    }
    if (type == 'Comment' && this.currentLevel == 4) {////Level3 Comment
      objTranBenchmarkKPI.condition = 11;
      message = 'Comment Saved Successfully.';
    }
    objTranBenchmarkKPI.actualValue = this.txtTranActualValue;

    this.uploadFiles();
    
    objTranBenchmarkKPI.userUno = this.login_UserID;
    this.restApi.addEditTranBenchMarkKPI_Inbox(objTranBenchmarkKPI)
      .subscribe(data => {

        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong');
          this.spinner.hide();
        }
        else {
          //Swal.fire({
          //  type: 'success',
          //  title: message,
          //  showConfirmButton: false,
          //  timer: 1500
          //})
         
          this.toaster.show('success', 'Success', message);
          
          //this.modalRef.hide();
          if (type == 'Comment') {
            this.kpiCommentForm.reset();
            this.getBenchMarkHistory(this.kpiBenchMarkTrnUno);
            this.modalRef.hide();
          }
          else {
            setTimeout(() => {
              this.spinner.hide();
              this.router.navigateByUrl('/benchmarkinbox');

            }, 2000);
          }
          

        }

        this.modalRef.hide()

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        //this.spinner.hide();
      });
    return true;

  }
  isNumberKey(evt) {
    
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }

  uploadFiles() {
    
    if (this.uploadedFiles && this.uploadedFiles.length > 0) {
      if (this.uploadedFiles.length > 5) {
        this.toaster.show('error', 'Error', 'Maximum 5 Files to be upload');
        return false;
      }
      let formData = new FormData();
      let isFileReadyForUpload = false;
      for (var i = 0; i < this.uploadedFiles.length; i++) {
        let allowFile = false;
        let fileName = this.uploadedFiles[i].name.toLowerCase();
        let fileSize = this.uploadedFiles[i].size;
        //Check file size
        let allowFileSize = false;
        allowFileSize = this.userService.checkFileSize(fileSize);
        if (!allowFileSize) {
          this.toaster.show('error', 'Error', 'A file size should not above 30MB.');
          return;
        }
        //To check filee size exe  
        allowFile = this.userService.checkFileValuranabity(fileName, fileSize);

        if (allowFile) {
          formData.append("file", this.uploadedFiles[i]);
          isFileReadyForUpload = true;
        }
      }
      if (isFileReadyForUpload) {

        formData.append("kpiUno", this.kpiCodeDetail.kpiUno.toString());
        formData.append("kpiTrnUno", this.kpiBenchMarkTrnUno.toString());
        formData.append("userID", this.login_UserID.toString());
        this.restApi.benchmarkKPIAttachmentUpload(formData)
          .subscribe(data => {
            
            if (data == null && data == undefined && data == '') {

            }
            else {
              //  this.toaster.show('success', 'Success', 'File uploaded.');
              //this.RefreshDirectory();
              //this.selectedRecord = new fileManager();
              this.uploadedFiles = [];


            }

            this.spinner.hide();
          },
            (error) => {
              this.spinner.hide();
            }
          ).add(() => {
            this.spinner.hide();
          });
      }
    }
    //else {
    //  this.toaster.show('error', 'Error', 'Please select the file');
    //}
  }

  getBenchmarkKPIAttachments(kpiTrnUno: number) {
    
    this.spinner.show();
    let inpValue = new kpiDynamic();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.userUno = this.login_UserID;

    this.restApi.getBenchmarkKpiAttachment(inpValue)
      .subscribe(data => {

        // let objData: any = data;
        
        this.dynamicAttachments = data;

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  getFileIconClass(fileTitle: string) {

    if (fileTitle == '' || fileTitle == null)
      return "fa fa-file";

    var rtnClass = "fa fa-file";
    var strTitle = (fileTitle.indexOf('.') > 0) ? fileTitle.split('.')[1].toLowerCase() : 'unknown';

    switch (strTitle) {
      case 'txt':
        rtnClass = "fa fa-file-o";
        break;
      case 'doc':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'docx':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'xls':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'xlsx':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'pdf':
        rtnClass = "fa fa-file-pdf-o";
        break;
      case 'gif':
      case 'jpeg':
      case 'jpg':
      case 'png':
        rtnClass = "fa fa-file-picture-o";
        break;
      case 'mp3':
        rtnClass = "fa fa-file-audio-o";
        break;
      case 'mp4':
      case 'mpeg':
      case 'mpg':
      case 'avi':
        rtnClass = "fa fa-file-video-o";
        break;
      default:
        rtnClass = "fa fa-file";
        break;
    }

    return rtnClass;

  }

  showKPIComment() {
    this.modalRef = this.modalService.show(
      this.CommentDialog,
      Object.assign({}, {
        class: 'gray modal-medium',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  addComment() {
    
    

      let comment = this.kpiCommentForm.get('comment').value;
      this.comments = (comment != null) ? comment : '';
    if (this.comments  == '') {
        this.toaster.show('warning', 'Warning', 'Please enter comment.');
        return false;
      }
      else {
        this.ApproveProcessBenchMarkEntry('', 'Comment');
      }
     
      
    return false;
  }

  showApporveRejectComment(type: string) {
    
    this.buttonType = type;
   
    this.modalRef = this.modalService.show(
      this.ApproveRejectDialog,
      Object.assign({}, {
        class: 'gray modal-medium',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  onSubmitApproveReject() {
    
    

      let comment = this.kpiApproveRejectForm.get('comment').value;
    this.comments = (comment != null) ? comment:'';
      if (this.buttonType == 'approve') {
        this.onApproveBenchMarkEntry('approve');
      }
      else if (this.buttonType == 'reject') {
        this.onApproveBenchMarkEntry('reject');
      }
   

    return false;
  }
}


